import { BaseDto } from '../../base/baseDto.model';

export class UpdateRolRequest  extends BaseDto{
}
